import script from "./addAccountPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./addAccountPopup.vue?vue&type=script&setup=true&lang=js"

import "./addAccountPopup.vue?vue&type=style&index=0&id=594c9e60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-594c9e60"]])

export default __exports__